export const megamenu = () => {
    const megamenus = document.querySelectorAll('.megamenu') as NodeListOf<HTMLDivElement>

    megamenus.forEach(wrapper => {
        const links = wrapper.querySelectorAll('.submenu__link') as NodeListOf<HTMLAnchorElement>
        const submenuItems = wrapper.querySelectorAll('.submenu__item') as NodeListOf<HTMLLIElement>
        const thirdLists = wrapper.querySelectorAll('.thirdmenu__list') as NodeListOf<HTMLUListElement>
        const thirdmenu = wrapper.querySelector('.thirdmenu') as HTMLDivElement
        const thirdTitles = wrapper.querySelectorAll('.thirdmenu__title') as NodeListOf<HTMLLIElement>
        const highlights = wrapper.querySelectorAll('.highlighted') as NodeListOf<HTMLDivElement>
        const thirdItems = wrapper.querySelectorAll('.thirdmenu__item') as NodeListOf<HTMLLIElement>

        if (!links.length || !thirdLists.length) return

        function showHighlight(id: string | null) {
            highlights.forEach(highlight => {
                if (highlight.dataset.highlightId === id) {
                    highlight.classList.add('active')
                } else {
                    highlight.classList.remove('active')
                }
            })
        }

        links.forEach((link, index) => {
            const correspondingItem = submenuItems[index]
            const highlightId = correspondingItem?.dataset.highlightId || null

            if (index === 0) {
                link.classList.add('active')
                thirdLists[index]?.classList.add('active')
                showHighlight(highlightId)
            }

            link.addEventListener('click', () => {
                thirdmenu?.classList.add('active')

                links.forEach(l => l.classList.remove('active'))
                thirdLists.forEach(list => list.classList.remove('active'))

                link.classList.add('active')
                thirdLists[index]?.classList.add('active')

                showHighlight(highlightId)
            })
        })

        thirdTitles.forEach(thirdTitle => {
            thirdTitle.addEventListener('click', () => {
                thirdmenu?.classList.remove('active')
                wrapper.querySelector('.thirdmenu__list.active')?.classList.remove('active')
                wrapper.querySelector('.submenu__item.active')?.classList.remove('active')
                showHighlight(null)
            })
        })

        thirdItems.forEach(item => {
            const highlightId = item.dataset.highlightId || null
            item.addEventListener('click', () => {
                showHighlight(highlightId)
            })
        })
    })
}
